import { DynamicDialogConfig } from 'primeng/dynamicdialog';

export class CustomDialogConfig<configurationType> extends DynamicDialogConfig {    
    configuration?: configurationType;
}